<template>
    <div class="files">
        <account-tabs
            v-model="currentTab"
            :tabs="tabs"
        />

        <div
            v-loading="isDataLoading"
            class="content"
        >
            <template v-if="currentTab === 'self'">
                <Button
                    :outline="!isMobile"
                    class="file_btn"
                    @click="uploadFileHandler"
                >Загрузить файл</Button>
                <input
                    hidden
                    ref="fileInput"
                    type="file"
                    @change="changeFileHandler"
                >
            </template>

            <div
                class="empty"
                v-if="!items.length"
            >
                {{ emptyText }}
            </div>

            <files-list
                v-else
                class="list"
                :items="currentItems"
            />
            
            <Button
                v-if="items.length > currentLimit"
                class="more_btn"
                @click="currentLimit = items.length"
            >Показать еще</Button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Button from '@/components/UI/Button';
import AccountTabs from '@/components/UI/AccountTabs';

import FilesList from './files/FilesList';

const filesActions = [
    'fetchGroupFiles',
    'fetchUserFiles',
    'uploadFile',
];

const filesGetters = [
    'getGroupFiles',
    'getUserFiles',
];

export default {
    name: 'Files',
    components: {
        Button,
        AccountTabs,
        FilesList,
    },
    data: () => ({
        currentTab: 'self',
        currentLimit: 6,
        isDataLoading: false,
        tabs: [
            {
                label: 'Общие',
                key: 'group',
            },
            {
                label: 'Мои',
                key: 'self',
            },
        ],
        fileToUpload: null,
    }),
    computed: {
        items() {
            switch (this.currentTab) {
                case 'group':
                    return this.getGroupFiles;
                case 'self':
                    return this.getUserFiles;
                default:
                    return [];
            }
        },
        currentItems() {
            return this.items.slice(0, this.currentLimit || items.length);
        },
        emptyText() {
            return {
                group: 'Нет общих материалов',
                self: 'Нет моих материалов',
            }[this.currentTab];
        },
        ...mapGetters('mentoring/files', filesGetters),
        ...mapGetters(["isMobile"]),
    },
    watch: {
        currentTab: {
            async handler(nv) {
                this.isDataLoading = true;
                switch (nv) {
                    case 'group':
                        try {
                            await this.fetchGroupFiles();
                            this.isDataLoading = false;
                        } catch (error) {
                            console.log(error);
                            this.isDataLoading = false;
                        }
                        break;
                    case 'self':
                        this.isDataLoading = true;
                        try {
                            await this.fetchUserFiles();
                            this.isDataLoading = false;
                        } catch (error) {
                            console.log(error);
                            this.isDataLoading = false;
                        }
                        break;
                    default:
                        this.isDataLoading = false;
                        break;
                }
            },
            immediate: true,
        },
    },
    methods: {
        uploadFileHandler() {
            this.$refs.fileInput.click();
        },
        async changeFileHandler(e) {
            const file = e.target.files[0];
            this.isDataLoading = true;
            try {
                await this.uploadFile(file);
                await this.fetchUserFiles();
                this.isDataLoading = false;

            } catch (error) {
                console.log(error);
                this.isDataLoading = false;
            }
        },
        ...mapActions('mentoring/files', filesActions),
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";
@import '@/styles/rem';
@import '@/styles/mrem';

.files{
    .content{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .file_btn{
            margin-bottom: rem(26);
            padding: 0 rem(24);
            @include on-mobile{
                width: 100%;
                margin-bottom: mrem(36);
            }
        }
        .empty {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #98A0A9;
            font-size: rem(15);
            line-height: rem(22);
            font-weight: 600;
            @include on-mobile{
                font-size: mrem(14);
                line-height: mrem(17);
                font-weight: 500;
            }
        }

        .preloader{
            position: absolute;
            z-index: 999;
            background-color: rgba(255, 255, 255, 0.9);
        }

        .list{
            margin-bottom: rem(6);
            @include on-mobile{
                margin-bottom: 0;
            }
        }

        .more_btn{
            padding: 0 rem(32);
            @include on-mobile{
                padding: auto;
                width: 100%;
            }
        }
    }
}

</style>